
export const DIARY_ENTRY_TYPE = {
  DIARY: 'diary' as const,
  HEARING_JOURNEY_TASK: 'hearingJourneyTask' as const,
};

export interface BaseDiaryEntry {
  type?: typeof DIARY_ENTRY_TYPE.DIARY | typeof DIARY_ENTRY_TYPE.HEARING_JOURNEY_TASK;
  id?: string;
  user: string;
  /* Can be from type ISO String or yyyy-mm-dd */
  date: string;
  experience: number;
  notes: string;
  fittingActivity?: CustomerActivityWithPhase;
  created: number;
  updated: number;
  createdISO: string;
  updatedISO: string;
}

export interface DiaryEntry extends BaseDiaryEntry {
  type?: typeof DIARY_ENTRY_TYPE.DIARY;
  situation: string;
  sound: string[];
  speechComprehension: string[];
  volume: string[];
  notes: string;
  deleted?: boolean;
  isLegacy?: boolean;
}

export interface HearingJourneyDiaryEntry extends BaseDiaryEntry {
  type: typeof DIARY_ENTRY_TYPE.HEARING_JOURNEY_TASK;
  hearingJourneyTaskId: string;
}

export type CustomerActivityWithPhase = {
  phase: number;
  active: boolean;
  activityId: CustomerActivityId;
  startDate: string;
  endDate: string | null;
  cancellationDateTime: string | null;
  cancellationReason: CancellationReason | null;
  tryOutDeviceList: EnrichedTryOutDevice[];
};

export type EnrichedTryOutDevice = DeviceIdentifier & Device & TryOutDeviceActivitySource;

type Device = {
  productId: string;
  product: string;
  changed: string;
  created: string;
  changed2: string;
  name: string;
  modelName: string;
  modelSeries: string;
  modelType: string;
  productGroup: string;
  productSubGroup: string;
  status: string;
  battery: boolean;
  manual: string;
  app: 'KINDduro' | 'KINDwings' | 'KINDilink' | null;
  tvInterface: 'connectline' | 'multistreamer' | 'surflink' | null;
  listeningDeviceType: string;
  features: string[];
  batteryDuration: string;
};

type DeviceIdentifier = {
  identifier: string;
};

type CustomerActivityId = string;

type CancellationReason = 'Ablehnung Kostenträger';

export type TryOutDeviceActivitySource = {
  axArticleNo: AxArticleNo;
  axVariant1: AxArticleVariant1;
  axVariant2: AxArticleVariant2;
  axVariant3: AxArticleVariant3;
  articleDescription: DeviceArticleDescription;
  serialNo: string;
  site: 'L' | 'R';
};

type AxArticleVariant = string;
type AxArticleVariant1 = AxArticleVariant;
type AxArticleVariant2 = AxArticleVariant;
type AxArticleVariant3 = AxArticleVariant;
type AxArticleNo = string;
type DeviceArticleDescription = string;

export type RecentDevice = {
  id: string;
  periodBegin: string;
  periodEnd: string;
  device: Device;
  positivityPercentage: number;
  tryOutDeviceList: EnrichedTryOutDevice[];
  numberOfDiaryEntries: number;
};

export type DiaryStatistics = {
  tendency: StatisticTendency;
  history: DiaryStatisticDataPoint[];
  statistics: StatisticValues;
};

type StatisticTendency = {
  currentExperience: number;
  trend: DiaryStatisticTrend;
};

type StatisticValues = {
  count: number;
};

export type DiaryStatisticDataPoint = {
  date: string;
  experience: number;
};

export type DiaryStatisticTrend =
  | 'slight improvement'
  | 'improvement'
  | 'slight deterioration'
  | 'deterioration'
  | 'constant'
  | 'fluctuating';
